import axios from 'axios';
import {compress, EncodeTypeEnum} from "./util/pako";

const runnerService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

const labService = axios.create({
  baseURL: process.env.REACT_APP_LAB_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// 请求拦截器
// runnerService.interceptors.request.use(
//   (config) => {
//     const token = config?.token;
//     if (token) {
//       config.headers.token = token;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// 一些接口报401不进行重定向
const inWhiteList = (url) => {
  const whiteList = ['/auth'];
  return whiteList.find(i => url.indexOf(i) > -1);
}

// 响应拦截器
runnerService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.status === 401 && !inWhiteList(error?.config?.url)) {
      const url = window.location.href;
      const isYuQue = url.indexOf('yuque') > -1;
      if (isYuQue) {
        window.location.href = `${process.env.REACT_APP_YUQUE_OAUTH_URL}${encodeURIComponent(url)}`;
      } else {
        window.location.href = process.env.REACT_APP_CLOUD_LAB_URL + "/login/callback?redirect=" + encodeURIComponent(url);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

const runCode = async (lang, code) => {
  try {
    const response = await runnerService.post('/run', {lang, code: compress(code), encodeScheme: 'PAKO'});
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getCode = async (oid) => {
  try {
    const response = await runnerService.get(`/code/${oid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


const saveCode = async (lang, code, oid) => {
  try {
    let compressed;
    if (code[1]||code[2]) {
      compressed = compress(JSON.stringify(code));
    }else{
      compressed = compress(code[0]);
    }
    const response = await runnerService.post('/code/save', {lang, oid, code: compressed, encodeScheme: 'PAKO'});
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getLangs = async () => {
  try {
    const response = await runnerService.get('/langs');
    return response.data;
  } catch (error) {
    throw error;
  }
};
/**
 * 获取/auth的状态
 */
const getAuthStatus = async (token) => {
  let path = '/auth';
  if (token){
    path += `?token=${token}`;
  }
  return runnerService.get(path)
};

const getLangTemplates = async (lang, token) => {
  try {
    const res = await runnerService.get(`/lab/templates?lang=${lang}`, { headers: { token } });
    return res;
  } catch (error) {
    throw(error);
  }
}

/**
 * 创建自定义环境
 */
const createEnv = async (params) => {
  try {
    const { token } = params;
    const response = await runnerService.post('/lab/createEnv', { ...params }, { headers: { token } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getQuotaPermit = async (token, labCode) => {
  try {
    const response = await labService.post('/api/v0.3/lab/quota/permit',
      {
        labCode: labCode,
        quotaType: "URI",
        quotaValue: "post /cmd/visual/save",
        data: {}
      },
      { headers: { token } });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
// 上传文件
const uploadFile = async (file) => {
  const response = await labService.post(`/api/v0.3/config/file/upload`, file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
  return response.data;
};
export const problemCommit = (params, token) => {
  return labService.post('/api/v0.3/qa/problem/commit', params, {
    headers: {
      'encodescheme': EncodeTypeEnum.BASE64,
      'TOKEN': token
    },
  });
}
//京师星河 的登录接口
export const login4Xhdt = async (xhdtToken) => {
  let response = await labService.post('/api/v0.3/xhdt/login',
    {"authType":"xhdt","userId": xhdtToken},
    {
      headers: {
      },
    });
  let data = response.data;
  console.log("login4Xhdt:", data);
  if (!data?.success){
    console.error("login4Xhdt error:", data)
    throw new Error(data.message);
  }
  return data.data;
}

export const sendSms = (phone) => {
   labService.post('/api/v0.3/config/sms',
    {"phone":phone, "type":1},
    {
      headers: {
      },
    })
    .then(response => {
      let data = response.data;
      console.log("sendSms:", data);
      if (!data?.success){
        console.error("sendSms error:", data)
        throw new Error(data.message);
      }
    });
}
export const bind4Xhdt = async (phone, smsCode, token) => {
  let response = await labService.post('/api/v0.3/xhdt/bind',
    {phone,smsCode},
    {
      headers: {
        token
      },
    });
  let data = response.data;
  console.log("bind4Xhdt:", data);
  if (!data?.success){
    console.error("bind4Xhdt error:", data)
    throw new Error(data.message);
  }
  return data.data;
}

export { runCode, getCode, saveCode, getLangs, getAuthStatus, getLangTemplates, createEnv, getQuotaPermit, uploadFile};
